import type { YammerState } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useEffect, useState } from 'react';
import { useStore } from 'react-redux';

import { isDogfoodPerfHUDEnabled } from './isEnabled';

export const useIsDogfoodPerfHUDEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const state = useStore<YammerState>().getState();
  const treatmentCacheKey = useExperimentTreatmentWithoutReporting('DogfoodPerfHUD');

  useEffect(() => {
    const getExperimentState = async () => {
      const result = await isDogfoodPerfHUDEnabled(state);
      setIsEnabled(result);
    };
    getExperimentState();
  }, [state, treatmentCacheKey]);

  return isEnabled;
};
